import { __assign } from "tslib";
import { Kind } from 'graphql';
var isExtensionNode = function (def) {
    return def.kind === Kind.OBJECT_TYPE_EXTENSION ||
        def.kind === Kind.INTERFACE_TYPE_EXTENSION ||
        def.kind === Kind.INPUT_OBJECT_TYPE_EXTENSION ||
        def.kind === Kind.UNION_TYPE_EXTENSION ||
        def.kind === Kind.ENUM_TYPE_EXTENSION ||
        def.kind === Kind.SCALAR_TYPE_EXTENSION ||
        def.kind === Kind.SCHEMA_EXTENSION;
};
export function filterAndExtractExtensionDefinitions(ast) {
    var extensionDefs = [];
    var typesDefs = [];
    ast.definitions.forEach(function (def) {
        if (isExtensionNode(def)) {
            extensionDefs.push(def);
        }
        else {
            typesDefs.push(def);
        }
    });
    return {
        typesAst: __assign(__assign({}, ast), { definitions: typesDefs }),
        extensionsAst: __assign(__assign({}, ast), { definitions: extensionDefs }),
    };
}
export function filterExtensionDefinitions(ast) {
    var typesAst = filterAndExtractExtensionDefinitions(ast).typesAst;
    return typesAst;
}
export function extractExtensionDefinitions(ast) {
    var extensionsAst = filterAndExtractExtensionDefinitions(ast).extensionsAst;
    return extensionsAst;
}
//# sourceMappingURL=extensionDefinitions.js.map